module.exports = __webpack_public_path__ + "media/images/logo-8dd029325d9363365be3f4c7c9c6299c.png";